import { Routes } from '@angular/router';
import { AuthGuard } from '@fantaz/shared/auth';
import { PageComponent } from '@fantaz/shared/ui/page';
import { TournamentDetailsFeatures } from '@fantaz/tournaments/features/details';
import { TournamentEvents } from '@fantaz/tournaments/features/events';
import { TournamentsListFeature } from '@fantaz/tournaments/features/list';
import { TournamentFeatureShellComponent } from './tournament-features-shell.component';

export const tournamentsShellRoutes: Routes = [
  {
    path: '',
    component: TournamentFeatureShellComponent,
    data: {
      breadcrumb: {
        label: 'Play',
        key: 'play',
        path: '/',
      },
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: TournamentsListFeature,
        canActivate: [],
      },
      {
        path: 'cash',
        component: PageComponent,
        data: { tournamentType: 'cash' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: '/tournaments??filterbytags=cash-tournament',
          },
          {
            path: ':tournamentId',
            component: PageComponent,
            data: {
              breadcrumb: {
                label: 'Details',
                key: 'tournamentName',
              },
            },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: TournamentEvents,
                canActivate: [],
              },
              {
                path: 'historydetails/:gameHistoryId',
                component: PageComponent,
                canActivate: [],
                data: {
                  breadcrumb: {
                    label: 'Tournament History Details',
                    key: 'tournamentHistoryDetails',
                  },
                },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    loadChildren: () =>
                      import('@fantaz/game-history-details').then(
                        (m) => m.GameHistoryDetailsModule,
                      ),
                  },
                  {
                    path: ':playInstanceId',
                    data: {
                      breadcrumb: {
                        label: 'Game Over',
                        key: 'gameGameOverId',
                      },
                    },
                    loadChildren: () =>
                      import('@fantaz/tournaments/features/game-over').then(
                        (m) => m.TournamentsFeaturesGameOverModule,
                      ),
                    canActivate: [AuthGuard],
                  },
                ],
              },
              {
                path: ':eventId',
                component: PageComponent,
                canActivate: [],
                data: {
                  breadcrumb: {
                    label: 'Tournament',
                    key: 'entryFee',
                  },
                },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: TournamentDetailsFeatures,
                  },
                  {
                    path: ':playInstanceId',
                    data: {
                      breadcrumb: {
                        label: 'Game Over',
                        key: 'gameGameOverId',
                      },
                    },
                    loadChildren: () =>
                      import('@fantaz/tournaments/features/game-over').then(
                        (m) => m.TournamentsFeaturesGameOverModule,
                      ),
                    canActivate: [AuthGuard],
                  },
                  {
                    path: 'historydetails/:gameHistoryId',
                    component: PageComponent,
                    canActivate: [],
                    data: {
                      breadcrumb: {
                        label: 'History Details',
                        key: 'tournamentHistoryDetails',
                      },
                    },
                    children: [
                      {
                        path: '',
                        pathMatch: 'full',
                        loadChildren: () =>
                          import('@fantaz/game-history-details').then(
                            (m) => m.GameHistoryDetailsModule,
                          ),
                      },
                      {
                        path: ':playInstanceId',
                        data: {
                          breadcrumb: {
                            label: 'Game Over',
                            key: 'gameGameOverId',
                          },
                        },
                        loadChildren: () =>
                          import('@fantaz/tournaments/features/game-over').then(
                            (m) => m.TournamentsFeaturesGameOverModule,
                          ),
                        canActivate: [AuthGuard],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: 'prizes',
        component: PageComponent,
        data: { tournamentType: 'prizes' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: '/tournaments??filterbytags=prize-tournament',
          },
          {
            path: ':tournamentId',
            pathMatch: 'full',
            redirectTo: '',
          },
          {
            path: ':tournamentId/:eventId',
            component: PageComponent,
            canActivate: [],
            data: {
              breadcrumb: {
                label: 'Details',
                key: 'tournamentName',
              },
            },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: TournamentDetailsFeatures,
              },
              {
                path: ':playInstanceId',
                data: {
                  breadcrumb: {
                    label: 'Game Over',
                    key: 'gameGameOverId',
                  },
                },
                loadChildren: () =>
                  import('@fantaz/tournaments/features/game-over').then(
                    (m) => m.TournamentsFeaturesGameOverModule,
                  ),
                canActivate: [AuthGuard],
              },
              {
                path: 'historydetails/:gameHistoryId',
                component: PageComponent,
                canActivate: [],
                data: {
                  breadcrumb: {
                    label: 'Tournament History Details',
                    key: 'tournamentHistoryDetails',
                  },
                },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    loadChildren: () =>
                      import('@fantaz/game-history-details').then(
                        (m) => m.GameHistoryDetailsModule,
                      ),
                  },
                  {
                    path: ':playInstanceId',
                    data: {
                      breadcrumb: {
                        label: 'Game Over',
                        key: 'gameGameOverId',
                      },
                    },
                    loadChildren: () =>
                      import('@fantaz/tournaments/features/game-over').then(
                        (m) => m.TournamentsFeaturesGameOverModule,
                      ),
                    canActivate: [AuthGuard],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
